<template>
  <div class="pipe-extraction bg-transparent rounded-2px z-99 w-full h-full pt-10px">
    <el-row :gutter="10" class="pr-5px">
      <el-col :span="12">
        <el-select
          v-model="searchData.deviceName"
          size="small"
          class="ml-5px"
          ref="fatherNode"
          popper-class="visualization-select-popper"
          placeholder="请选择装置"
          filterable
        >
          <el-input
            placeholder="此处输入关键词搜索查询"
            prefix-icon="el-icon-search"
            v-model="treeFilterKey"
            size="mini"
            clearable
          ></el-input>
          <el-option
            hidden
            key="id"
            :label="searchData.deviceName"
            :value="searchData.deviceName"
          ></el-option>
          <el-tree
            v-loading="deviceTreeLoading"
            ref="smallTreeDom"
            :data="treeData"
            empty-text="暂无数据"
            highlight-current
            :props="defaultTreeProps"
            :expand-on-click-node="false"
            :default-expand-all="false"
            :filter-node-method="filterTreeNode"
            @node-click="treeSelect"
            class="device-tree text-14px"
          >
          </el-tree>
        </el-select>
      </el-col>
      <el-col :span="12">
        <el-input
          size="small"
          v-model="searchData.tagCode"
          placeholder="请输入管道编码"
          clearable
          class="ml-5px"
        ></el-input>
      </el-col>
    </el-row>
    <el-row :gutter="10" class="pr-5px mt-10px">
      <el-col :span="12">
        <el-select
          size="small"
          class="ml-5px"
          popper-class="visualization-select-popper"
          v-model="searchData.medium"
          placeholder="请选择介质"
          filterable
          clearable
        >
          <el-option
            v-for="item in mediumList"
            :label="item.value"
            :value="item.key"
            :key="item.key"
          />
        </el-select>
      </el-col>
      <el-col :span="12" class="search-wrap h-36px leading-36px flex items-center">
        <el-button @click="searchHandler" size="small" type="primary" class="ml-5px"
          >搜索</el-button
        >
        <span class="whitespace-nowrap text-[#fff] ml-5px text-14px">抽离</span>
        <el-switch
          class="ml-5px"
          v-model="allFlowStatus"
          :disabled="allFlowDisabled"
          @change="changeAllStatus"
          inactive-text-color="#fff"
          active-color="#45f2eb"
        ></el-switch>
      </el-col>
    </el-row>

    <el-table
      ref="markerTable"
      :data="tableData"
      v-loading="tableLoading"
      height="calc(100% - 138px)"
      :row-key="(row) => row.tagId"
      class="markerTable mt-10px"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
      @row-click="moveToPipe"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column show-overflow-tooltip prop="deviceName" label="装置名称"></el-table-column>
      <el-table-column show-overflow-tooltip prop="tagName" label="管道名称"></el-table-column>
      <el-table-column show-overflow-tooltip prop="medium" label="介质">
        <template slot-scope="{ row }">
          <span>{{ getMediumName(row.medium) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="60">
        <template slot-scope="{ row }">
          <div class="flex justify-center items-center">
            <span @click.stop="" class="flex items-center ml-5px">
              <el-switch
                :width="40"
                v-model="row.status"
                @change="changeStatus(row)"
                inactive-text-color="#fff"
                active-color="#45f2eb"
              ></el-switch>
            </span>
          </div>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      small
      background
      @current-change="getTableData"
      :current-page.sync="page.pageNo"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
      :pager-count="5"
      class="flex justify-end mt-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { isEmpty, findIndex, filter, map, forEach } from 'lodash'
import { ThreeDimensionsApi } from '@wiz-api/guang-xi-shi-hua'
import { ModelApi } from '@wiz-api/material-management'
import { FileApi } from '@wiz-api/file-management'

const modelApi = new ModelApi()
const fileApi = new FileApi()
const threeDimensionsApi = new ThreeDimensionsApi()
export default {
  components: {},
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
    deviceInfo: {
      type: Object,
      defalut: () => {
        return {
          deviceName: null,
          deviceId: null,
          modelId: null,
        }
      },
    },
  },
  data() {
    return {
      deviceTreeLoading: false,
      allFlowDisabled: true,
      tableLoading: false,
      allFlowStatus: false, // 批量流向动画展示
      treeFilterKey: null,
      curRootItem: null, // 当前根节点
      currentDeviceId: null, // 当前装置id
      currentModelId: null, // 当前的模型id
      defaultTreeProps: {
        children: 'children',
        label: 'deviceName',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      searchData: {
        deviceName: null,
        tagCode: null,
        medium: null,
      },
      tableData: [],
      treeData: [], // 装置treeData
      deviceList: [], // 装置列
      mediumList: [], // 介质列
      currentShowPipes: [], // 当前抽离出的管线
      currentSelectedPipe: [], // 表格多选
      rootNodeVisible: true,
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return (
        Wiz.globalSettings.globalConfig?.modelSetting ||
        _.get(Wiz, 'globalSettings.dynamicModules.modules["visualization-cockpit"].config')
          ?.modelSetting ||
        {}
      )
    },
  },
  watch: {
    treeFilterKey(val) {
      this.$refs.smallTreeDom.filter(val)
    },
  },
  async created() {
    // 装置
    this.getDeviceList()
    // 介质
    this.getMediumList()
  },
  async beforeDestroy() {
    const rootNode = await this.player.Native.Node.getRoot()
    if (rootNode && !this.rootNodeVisible) {
      await this.player.Native.Node.setProperty(rootNode, { visible: true })
      this.rootNodeVisible = true
    }
  },
  methods: {
    // 通过key获取介质名称
    getMediumName(key) {
      const index = findIndex(this.mediumList, ['key', key])
      if (index > -1) {
        return this.mediumList[index].value
      }
      return ''
    },
    // 装置树检索
    filterTreeNode(value, data) {
      if (!value) return true
      return data.deviceName.indexOf(value) !== -1
    },
    // 装置树选择
    treeSelect(data) {
      if (!data.modelId) {
        this.$message.warning('该装置未绑定模型')
        return
      }
      if (this.currentDeviceId === data.id) {
        console.log('same device')
        return
      }
      this.$emit('loadingSwitch', { bol: true, title: '正在切换装置' })
      this.player.Native.Node.EventLoadFileFinish.connect(this.checkModelLoadEnd)
      this.searchData.deviceName = data.deviceName
      this.currentDeviceId = data.id
      this.currentModelId = data.modelId
      this.$emit('updateDeviceInfo', {
        deviceName: data.deviceName,
        deviceId: data.id,
        modelId: data.modelId,
      })
      this.$refs.fatherNode.blur()
      this.resetData()
      this.getModelDetail() // 获取模型详情
      this.searchHandler() // 获取管线列表
    },
    // 重置数据
    async resetData() {
      this.currentShowPipes = [] // 清空动画列表
      this.currentSelectedPipe = [] // 清空多选
      this.tableData = [] // 清空表单
      this.rootNodeVisible = true
    },
    // 监听模型切换加载完成操作
    checkModelLoadEnd(t, nds) {
      console.log('切换监听加载结束', t, nds)
      this.$emit('loadingSwitch', { bol: false, title: '正在切换装置' })
      setTimeout(() => {
        this.player.Native.Node.EventLoadFileFinish.disconnect(this.checkModelLoadEnd)
      }, 100)
    },
    // 获取模型详情信息
    async getModelDetail() {
      const [err, res] = await modelApi.get(this.currentModelId)
      if (!err && res?.medias) {
        const modelInfo = _.find(res.medias, ['mediaType', 1])
        const textureInfo = _.find(res.medias, ['mediaType', 2])
        console.log('获取切换模型详情', err, res)
        if (modelInfo?.fileInfoId) {
          // 获取模型文件详情，确定文件类型
          let fileType = 'pr'
          const [fileErr, fileRes] = await fileApi.get(modelInfo.fileInfoId)
          if (!fileErr && fileRes?.name) {
            fileType = _.last(fileRes.name.split('.')) || 'pr'
          }
          console.log('获取的文件详情', fileErr, fileRes)
          const modelDetail = {
            filePath: `data://../apps/${this.modelSetting.folderName}/models/${modelInfo.fileInfoId}/${modelInfo.fileInfoId}.${fileType}`,
            materialFileId: textureInfo ? textureInfo.fileInfoId : '',
            modelFileId: modelInfo.fileInfoId,
          }
          this.$emit('changeModel', modelDetail)
        } else {
          this.$message.warning('模型文件不存在')
        }
      }
    },
    // 表格多选
    handleSelectionChange(val) {
      this.currentSelectedPipe = val
      this.resetSwitchStatus()
    },
    // 全量修改抽离状态
    async changeAllStatus(val) {
      const rootNode = await this.player.Native.Node.getRoot()
      if (!rootNode) return
      if (val) {
        // 开启抽离
        if (this.rootNodeVisible) {
          // 如果全场未隐藏，先隐藏
          this.player.Native.Node.setProperty(rootNode, { visible: false })
          this.rootNodeVisible = false
        }
        const codeCol = map(this.currentSelectedPipe, 'tagCode')
        const codeInfoCol = await this.player.Native.Node.findNode(rootNode, {
          codes: codeCol,
        })
        if (codeInfoCol?.codes && !isEmpty(codeInfoCol.codes)) {
          const nodeCol = map(Object.values(codeInfoCol.codes), 'node')
          this.player.Native.Node.setProperty(nodeCol, { visible: true })
          this.currentShowPipes.push(
            ...map(Object.values(codeInfoCol.codes), (item) => {
              return { node: item.node, code: item.code }
            })
          )
          console.log('当前已经抽离', this.currentShowPipes)
        }
      } else {
        // 关闭抽离
        const needCloseNodes = []
        const needCloseCodes = []
        console.log('currentSelectedPipe', this.currentSelectedPipe, this.currentShowPipes)
        for (let i = 0; i < this.currentSelectedPipe.length; i += 1) {
          const showIndex = findIndex(this.currentShowPipes, [
            'code',
            this.currentSelectedPipe[i].tagCode,
          ])
          console.log('index', showIndex)
          if (showIndex > -1) {
            needCloseNodes.push(this.currentShowPipes[showIndex].node)
            needCloseCodes.push(this.currentShowPipes[showIndex].code)
          }
        }
        if (needCloseNodes.length) {
          console.log('需要隐藏的node', needCloseNodes)
          await this.player.Native.Node.setProperty(needCloseNodes, { visible: false })
        }
        this.currentShowPipes = filter(this.currentShowPipes, (item) => {
          return !needCloseCodes.includes(item.code)
        })
        console.log('清理后仍显示的管线', this.currentShowPipes)
        if (isEmpty(this.currentShowPipes)) {
          console.log('没有抽离节点，就全显示')
          // 如果当前没有抽离节点，就全显示
          this.player.Native.Node.setProperty(rootNode, { visible: true })
          this.rootNodeVisible = true
        }
      }
    },
    // 获取装置下拉列表
    async getDeviceList() {
      this.deviceTreeLoading = true
      const [err, res] = await threeDimensionsApi.getDeviceList({
        isTree: true,
        body: {
          name: null,
        },
      })
      this.deviceTreeLoading = false
      if (!err && res) {
        const filterTree = (nodes) => {
          const filterNode = (node) => {
            if (!node.modelId) {
              return null
            }
            if (node.children && node.children.length > 0) {
              const filteredChildren = node.children.map(filterNode).filter((child) => {
                return child !== null
              })
              node.children = filteredChildren.length > 0 ? filteredChildren : []
            }

            return node
          }
          return nodes.map(filterNode).filter((node) => {
            return node !== null
          })
        }
        this.treeData = filterTree(res)
        if (res.length) {
          if (this.deviceInfo.deviceId) {
            this.searchData.deviceName = this.deviceInfo.deviceName
            this.currentDeviceId = this.deviceInfo.deviceId
            this.currentModelId = this.deviceInfo.modelId
          } else {
            this.searchData.deviceName = res[0].deviceName
            this.currentDeviceId = res[0].id
            this.currentModelId = res[0].modelId
          }
          this.searchData = Object.assign(this.searchData, {
            tagCode: null,
            medium: null,
          })
          this.searchHandler() // 获取全场管线数据
        }
      }
    },
    // 获取材质列表
    async getMediumList() {
      const [err, res] = await threeDimensionsApi.getSysDatat({
        parentKey: 'Medium',
      })
      if (!err && res?.code && res.code === '200' && res.data) {
        this.mediumList = res.data
      }
    },
    // 获取管线表数据
    async getTableData() {
      // currentDeviceId
      this.tableLoading = true
      const [err, res] = await threeDimensionsApi.getDeviceRelationPipeLineList({
        body: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          deviceId: this.currentDeviceId,
          tagCode: this.searchData.tagCode ? `%${this.searchData.tagCode}%` : null,
          medium: this.searchData.medium,
        },
      })
      this.tableLoading = false
      if (!err && res?.code && res.code === '200' && res.data?.items) {
        this.tableData = res.data.items
        this.page.total = res.data.totalCount
      }
    },
    // 当单个管线的按钮状态切换时，调整总体抽离开关状态
    resetSwitchStatus() {
      if (this.currentSelectedPipe?.length) {
        this.allFlowDisabled = false
        const codeWithAnimation = map(this.currentShowPipes, (item) => {
          return item.code
        })
        let hasNoAnimationPipe = false
        // 判断多选项里是否有还未加载动画的管线
        try {
          forEach(this.currentSelectedPipe, (item) => {
            if (!codeWithAnimation.includes(item.tagCode)) {
              hasNoAnimationPipe = true
              throw new Error()
            }
          })
          // eslint-disable-next-line no-empty
        } catch (e) {}
        if (hasNoAnimationPipe) {
          // 有未打开抽离的管线、将状态改为false
          this.allFlowStatus = false
        } else {
          // 无未打开的抽离，则按钮为true，可执行关闭操作
          this.allFlowStatus = true
        }
      } else {
        this.allFlowDisabled = true
      }
    },
    // 搜索
    searchHandler() {
      this.page.pageNo = 1
      this.getTableData()
    },
    async moveToPipe(row) {
      if (row.tagCode) {
        const rootNode = await this.player.Native.Node.getRoot()
        const codeData = await this.player.Native.Node.findNode(rootNode, {
          codes: [row.tagCode],
        })
        console.log('通过位号找到的node信息', codeData)
        const codes = codeData?.codes
        if (codes && codes[row.tagCode] && codes[row.tagCode].node) {
          // 计算节点包围盒
          const NodeInfo = await this.player.Native.Node.getProperty(codes[row.tagCode].node, [
            'aabb',
          ])
          // 相机移动到包围盒位置
          this.player.Native.Camera.moveToAabbWithFace(NodeInfo.aabb, 1, 25)
        }
      }
    },
  },
}
</script>
<style lang="scss">
.visualization-select-popper {
  .el-select-dropdown__list {
    padding: 5px !important;
  }
}
</style>
<style lang="scss" scoped>
.search-wrap {
  ::v-deep .el-button {
    height: 28px !important;
    line-height: 28px !important;
    border-radius: 5px !important;
  }
}
.markerTable {
  ::v-deep .el-checkbox {
    margin: 0 !important;
  }
  ::v-deep .el-table th.is-leaf,
  .el-table td {
    border: none !important;
  }
}
::v-deep.device-tree {
  overflow-y: auto;
  height: 100%;
  color: #fff;
  background-color: transparent !important;

  .el-tree-node__content:hover {
    background: #0499a744 !important;
  }

  .el-tree-node.is-current > .el-tree-node__content {
    background: #049aa780 !important;
  }

  .el-tree-node:focus > .el-tree-node__content {
    background: #049aa780 !important;
  }
  .el-tree-node__label {
    color: #fff !important;
  }

  .custom-tree-node {
    width: 100%;
    font-size: 14px;
  }
}
.pipe-extraction {
  ::v-deep .el-slider__bar {
    background: #11939d !important;
  }
  ::v-deep .el-slider__button {
    width: 10px !important;
    height: 10px !important;
    border: 2px solid #11939d !important;
  }
}
::v-deep {
  .el-pagination.is-background.el-pagination--small .btn-next,
  .el-pagination.is-background.el-pagination--small .btn-prev,
  .el-pagination.is-background.el-pagination--small .el-pager li {
    padding: 0 !important;
    margin: 0 3px !important;
  }
}
</style>
